module.exports = __webpack_public_path__ + "static/img/manjianquan.72c82d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/manjianquan.jpg
// module id = r2q5
// module chunks = 128